<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Medicamento OBM"
    >
        <List :data="{model}" />

         <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="store"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

// Mixins.
import {error, object, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {List},
    created() {
        this.repositories = {
            entrada: this.getConectaSusRepository('almoxarifado.entrada'),
            material: this.getConectaSusRepository('cadastro.material'),
        }
    },
    data: () => ({
        materialId: null,
        model: {
            integracaoBnafarMedicamentos: [],
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(materialId) {
            this.materialId = materialId

            this.$refs.RkmModal.show()

            this.load()
        },
        load() {
            this.setLoading()

            const request = {
                listar: 'integracao-bnafar-medicamentos',
                material_id: this.materialId,
            }

            this.repositories.entrada.list(request)
                .then((response) => this.model.integracaoBnafarMedicamentos = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            const request = this.model.integracaoBnafarMedicamentos.map(integracaoBnafarMedicamento => integracaoBnafarMedicamento.medicamentoId)

            this.setLoading()

            this.repositories.material.storeIntegracaoBnafarMedicamentos(this.materialId, request)
                .then(() => {
                    this.showSaveNotification()
                    this.$refs.RkmModal.hide()
                    this.$emit('save')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, object, repository],
}
</script>